import { retrieveUserSession } from 'lib/core/session';
import { User } from 'interfaces/user';

export const useSession = () => retrieveUserSession() as User;
